module.exports = "<div class=\"weui_navbar\">\n  <navbar-item v-for=\"item in translatedItems\" :key=\"item.key\"\n  :is-selected=\"item.key === selected\" @weui-item-select=\"selectItem\">\n    {{item.text}}\n  </navbar-item>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tab/navbar.vue
 ** module id = 140
 ** module chunks = 0
 **/